import { breakpoints, Stack, Text, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import QRCode from 'react-qr-code';
import { paymentMethodCodes } from '../payment/constants/paymentMethods';

const qrCodeWrapperStyles = css`
  align-items: center;
  display: flex;
  flex-direction: column;
  max-width: 210px;
`;

const bottomWrapperStyles = css`
  align-items: center;
  display: flex;
  flex-direction: column;

  p {
    text-align: center;
  }
`;

const topCornerStyles = css`
  position: relative;
  width: 100%;

  ::before,
  ::after {
    border-block-start: 4px solid ${vars.colors.decoration.primary};
    content: '';
    height: 40px;
    inset-block-start: 0;
    position: absolute;
    width: 40px;
  }

  ::before {
    border-inline-start: 4px solid ${vars.colors.decoration.primary};
    border-start-start-radius: 5px;
  }

  ::after {
    border-inline-end: 4px solid ${vars.colors.decoration.primary};
    border-start-end-radius: 5px;
    inset-inline-end: 0;
  }
`;

const bottomCornerStyles = css`
  position: relative;
  width: 100%;

  ::before,
  ::after {
    border-block-end: 4px solid ${vars.colors.decoration.primary};
    bottom: 0;
    content: '';
    height: 40px;
    inset-block-end: 0;
    position: absolute;
    width: 40px;
  }

  ::before {
    border-end-start-radius: 5px;
    border-inline-start: 4px solid ${vars.colors.decoration.primary};
  }

  ::after {
    border-end-end-radius: 5px;
    border-inline-end: 4px solid ${vars.colors.decoration.primary};
    inset-inline-end: 0;
  }
`;

const qrCodeStyles = css`
  height: auto;
  max-width: 100%;
  padding: 24px;
  width: 100%;
`;

interface QrCodeProps {
  code: string;
  data: string;
}

const ProcessingQrCode = ({ code, data }: QrCodeProps) => {
  const { t } = useTranslation();
  const isMobileDevice = window.matchMedia(`(max-width: ${breakpoints._768})`).matches;

  const deviceRelatedText: string =
    isMobileDevice && code === paymentMethodCodes.PAYNOW
      ? t(`Processing.${code}.Qrcode.Mobile.Text`)
      : t(`Processing.${code}.Qrcode.Text`);

  return (
    <Stack
      className={bottomWrapperStyles}
      data-testid={`processing-${code.toLowerCase()}-qrcode`}
      spacing={16}
    >
      <Text aria-hidden="true" as="p">
        {deviceRelatedText}
      </Text>
      <div className={qrCodeWrapperStyles}>
        <div className={topCornerStyles} />
        <QRCode
          className={qrCodeStyles}
          data-testid={`processing-${code.toLowerCase()}-qrcode-image`}
          role="img"
          title={deviceRelatedText}
          value={data}
        />
        <div className={bottomCornerStyles} />
      </div>
    </Stack>
  );
};

export default ProcessingQrCode;
